import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import styles from './LinkDebitCard.module.css';
import { FormField } from '../../../../forms/formField/index';

export function CardholderNameQuestion() {
    return (
        <div className={styles.field}>
            <FormField
                label={
                    <FormattedMessage
                        id="_.link_debit_card.cardholder_name"
                        defaultMessage="Cardholder name"
                    />
                }
                className={classNames(styles.cardholderName, 'fs-exclude')}
                name="cardholderName"
                placeholder="John Smith"
            />
        </div>
    );
}
